import Vue from 'vue';
import RebateStatusesQuery from '@/plugins/graphql/queries/v2/store_add_ons/rebates-by-status.gql';
import { RebatesByStatusModel } from '@/helpers/entities/models/RebatesByStatusModel';
export default Vue.extend({
    apollo: {
        rebates: {
            query: RebateStatusesQuery,
            variables() {
                return {
                    appUuid: this.appUuid,
                    status: this.status,
                };
            },
            update(data) {
                const rebateStatuses = data.fetchRebatesByStatus.edges;
                const rebateStatusNodes = (rebatesStatus) => {
                    return new RebatesByStatusModel(rebatesStatus.node);
                };
                return rebateStatuses.map(rebateStatusNodes);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            rebates: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.rebates.length >= 1) {
                return self.rebates.map((rebate) => {
                    let firstName = '';
                    let lastName = '';
                    const voucherCodes = [];
                    const storeNames = [];
                    if (rebate.customerDetail) {
                        firstName = rebate.customerDetail.firstName;
                        lastName = rebate.customerDetail.lastName;
                    }
                    if (rebate.vouchers) {
                        rebate.vouchers.forEach((voucher) => {
                            voucherCodes.push(`${voucher.serialId} - ₱${voucher.amount}`);
                        });
                    }
                    rebate.storeReceipts.forEach((storeReceipt) => {
                        storeNames.push(storeReceipt.app.name);
                    });
                    return {
                        submissionId: rebate.id,
                        dateOfSubmission: rebate.formattedCreatedAt,
                        firstName,
                        lastName,
                        storeName: storeNames.join(', '),
                        amountPurchase: rebate.totalAmount,
                        dateApproved: rebate.formattedApprovedAt,
                        serialId: voucherCodes.join(', '),
                        dateRejected: rebate.formattedRejectedAt,
                        verifiedBy: rebate.verifiedBy,
                        status: rebate.status,
                    };
                });
            }
            return [];
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                rebates: self.dataForCsv,
            });
        }
    },
});
